import { Component, Input } from '@angular/core';
import { ClubOverviewService } from '~features/club-overview/club-overview.service';
import { FormLabelTranslationService } from '~shared/components/form-fields/translations/form-label-translations.service';
import { Club } from '~core/models';
import { TooltipTranslationService } from '~shared/translations';

/**
 * Displays customer data inside an info tile
 */
@Component({
  selector: 'app-club-communication-info',
  templateUrl: './club-communication-info.component.html',
  styleUrls: ['../../../pages/club-settings/club.component.scss']
})
export class ClubCommunicationInfoComponent {
  @Input() public selectedClub: Club;
  public yesOrNoDropdown: Array<any> = [];

  constructor(
    public clubOverviewService: ClubOverviewService,
    public tooltipTranslations: TooltipTranslationService,
    public flTranslations: FormLabelTranslationService,
  ) {
    this.yesOrNoDropdown.push(
      { value: true, status: this.flTranslations.i18nYes },
      { value: false, status: this.flTranslations.i18nNo },
    );
  }

  public getTranslatedStatus(status) {
    const translated = this.yesOrNoDropdown.find(el => el.value === status);
    return translated.status ?? null;
  }
}
